(function () {

    'use strict';

    angular.module('asys')
        .directive('asysErgebnisListe', ergebnisListe);

    ergebnisListe.$inject = [];
    function ergebnisListe() {
        return {
            restrict: 'E',
            templateUrl: 'reiter/ergebnis/partials/ergebnisListe.html'
        };
    }
})();
